import React from "react";
import { Box, Button, Drawer, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import logo from "assets/logo/Sage2.0-logo.png";
import localStorageMethods from "helpers/localStorage";
import { useLocation, useNavigate } from "react-router";
import { publicPaths } from "router/paths";
import { useAppDispatch } from "store/hooks";
import { signOutAction } from "features/authDashboard/actions/signOut.action";
import "./sidebar.scss";
import { Menu } from "./Menu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { resetSavedTransactionLogsSearchFilter } from "features/adminDashboard/slices/saveTimeDropdownSelection.slice";

const menu = Menu;
const drawerWidth = 220;
const Sidebar = () => {
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const username = localStorageMethods.getItemFromLocalStorage("username");

  const handleLogOut = () => {
    localStorageMethods.emptyLocalStorage();
    navigate(publicPaths.home);
    dispatch(signOutAction(username));
    dispatch(resetSavedTransactionLogsSearchFilter());
  };

  const onListItemClick = (itemTitle) => {
    navigate(itemTitle.path);
  };

  return (
    <Drawer
      variant="permanent"
      className="sidebar-root"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <Box sx={{ px: 4, py: 1 }}>
        <img src={logo} width={160} height={60} />
      </Box>
      <Box sx={{ overflow: "auto", mt: 5 }}>
        <List>
          {menu.map((menuItem) => (
            <ListItemButton
              className={menuItem.path === currentLocation.pathname ? "menu-selected" : "menu-not-selected"}
              key={menuItem.name}
              onClick={() => onListItemClick(menuItem)}
              sx={{ mb: 4, mt: 1, fontSize: "0.87rem" }}
              disabled={menuItem.disabled}
            >
              <ListItemIcon className={menuItem.path === currentLocation.pathname ? "menu-selected" : "menu-not-selected"}>
                {menuItem.icon}
              </ListItemIcon>
              <ListItemText primary={menuItem.name} primaryTypographyProps={{ fontSize: "0.875rem" }} />
            </ListItemButton>
          ))}
        </List>
        <Box display="flex" justifyContent="center">
          <Button sx={{ overflowWrap: "anywhere" }} variant="contained" className="logout-btn" onClick={handleLogOut} startIcon={<ExitToAppIcon />}>
            LOGOUT
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
